<template>
  <div class="opb">
    <button class="item main-opb" v-on:click="showActions">
      <HumorEmojis class="float-emoji" :humor="activeHumor" />
    </button>
    <ul>
      <li v-for="(obj, index) in validHumors.filter(x => x.key != activeHumor)" :key="index">
        <template v-if="obj.key != 0">
          <span class="btn-text" >{{obj.value}}</span>
          <button class="item" v-on:click="emitHumor(obj.key)">
            <HumorEmojis class="float-emoji" :humor="obj.key" />
          </button>
        </template>        
      </li>      
    </ul>
  </div>
</template>

<script>
import HumorEmojis from "./HumorEmojis.vue";

export default {
    name:"FloatHumorSelect",
    components: {
        HumorEmojis
    },
    props: {
        activeHumor:{type:Number},
        disable:{type:Boolean}
    },
    data() {
        return {            
            validHumors: [{key:0, value:"Não Informado"}, {key:1, value:"Péssimo"}, {key:2, value:"Ruim"}, {key:3, value:"Bem"}, {key:4, value:" Muito Bem"}, {key:5, value:"Excelente"}],
        }
    },
    methods: {
        toggleFAB(){
          if (this.disable) {return;}

	        if(document.querySelector('.opb').classList.contains('show')){
      	        document.querySelector('.opb').classList.remove('show');
            }else{
      	        document.querySelector('.opb').classList.add('show');
            }
        },
        showActions() {          
          if (this.disable) {return;}

          this.toggleFAB();
        },
        emitHumor(humor) {
          if (this.disable) {return;}
          this.toggleFAB();
          this.$emit("humor", humor);
        }
    }
}
</script>


<style lang="css">
    @import"./style.css";
</style>
